module.exports = __webpack_public_path__ + "static/media/Jeepers-01.e57fea4f.svg";